module.exports = __webpack_public_path__ + "img/A2-bgi.6fd55f59.png";